<template>
  <!-- BEGIN: Content-->
  <div class="app-content content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top profile__avatar">
            <div class="col-12">
              <h2 class="content-header-title mb-0">
                {{ title }}
              </h2>
              <BriefExplanation section="conferences.header" />
            </div>
          </div>
        </div>
        <div
          class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none"
        >
          <div class="mb-1 breadcrumb-right">
            <a
              v-if="hasPermission('create conferences')"
              class="btn btn-icon btn-primary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              :href="$router.resolve({ name: 'researcher.conferences.create', query: { actAs: $route.query.actAs } }).href"
              target="_blank"
            ><i data-feather="plus" /></a>
            <!-- <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Professional background settings"
            ><i data-feather="settings" /></a> -->
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <CompleteTable
              :sorted-field="sortedField"
              :data="items"
              :sort-mapping="sortMapping"
              :title="'conferences, workshops & invited talks'"
              :total="itemsTotal"
              :fetch-path="'activities/fetch'"
              :filter-path="'activities/filter'"
              :export-path="'activities/export'"
            >
              <template v-slot="{field, showInfoSheet}">
                <td
                  class="text-end"
                >
                  <b-dropdown
                    variant="link"
                    no-caret
                    toggle-class="p-0"
                    right
                  >
                    <template #button-content>
                      <i data-feather="more-vertical" />
                    </template>
                    <div
                      class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
                    >
                      <b-dropdown-item
                        :href="$router.resolve({ name: 'researcher.dashboard', params: { id: field.user.id }, query: { actAs: $route.query.actAs } }).href"
                        target="_blank"
                      >
                        <i
                          class="me-50"
                          data-feather="user"
                        /> View researcher profile
                      </b-dropdown-item>
                      <b-dropdown-item @click="showInfoSheet(field)">
                        <i
                          class="me-50"
                          data-feather="eye"
                        /> View activity
                      </b-dropdown-item>
                      <div class="dropdown-divider" />
                      <b-dropdown-item
                        v-if="hasPermission('update conferences')"
                        :href="$router.resolve({ name: 'researcher.conferences.edit', params: { id: field.id }, query: { actAs: $route.query.actAs } }).href"
                        target="_blank"
                      >
                        <i
                          class="me-50"
                          data-feather="edit-3"
                        /> Edit
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="hasPermission('delete conferences')"
                        @click="showDeleteModal(field)"
                      >
                        <i
                          class="me-50"
                          data-feather="trash-2"
                        /> Delete <span class="float-end"><i data-feather="lock" /></span>
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                  <a
                    href=""
                    class="btn btn-icon btn-light-secondary d-block d-sm-none"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMenu"
                    aria-controls="offcanvasBottom"
                  ><i
                    data-feather="more-vertical"
                  /></a>
                </td>
              </template>
              <template #customfilters>
                <div
                  v-if="hasAdminPermission('view conferences')"
                  class="mb-1"
                >
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Researcher</label>
                  <v-select
                    v-model="filters.researcher"
                    label="name"
                    :options="users"
                    :get-option-key="option => option.id"
                    @search="onSearch({ name: $event }, 'users/fetchFakeUsers')"
                    @input="saveFilter({ customLabel: true, name: `Researcher: ${$event ? $event.name : ''}`, value: $event }, 'researcher')"
                  />
                  <hr>
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Title</label>
                  <input
                    v-model="filters.title"
                    type="text"
                    class="form-control"
                    name="nameseniorcall"
                    @change="saveFilter({ customLabel: true, name: `Title: ${$event.target.value}`, value: `${$event.target.value}` }, 'title')"
                  >
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Event / place name</label>
                  <input
                    v-model="filters.place_name"
                    type="text"
                    class="form-control"
                    name="nameseniorcall"
                    @change="saveFilter({ customLabel: true, name: `Event / place name: ${$event.target.value}`, value: `${$event.target.value}` }, 'place_name')"
                  >
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Type of activity</label>
                  <v-select
                    v-model="filters.activity_types"
                    label="name"
                    :options="types"
                    :get-option-key="option => option.id"
                    @search="onSearch({ name: $event }, 'activityTypes/filter')"
                    @input="saveFilter({ customLabel: true, name: `Type of activity: ${$event ? $event.name : ''}`, value: $event }, 'activity_types')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Country</label>
                  <v-select
                    v-model="filters.country"
                    label="name"
                    :options="countries"
                    @input="saveFilter({ customLabel: true, name: `Country: ${$event ? $event.name : ''}`, value: $event }, 'country')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Begin date</label>
                  <br>
                  <date-picker
                    v-model="filters['begin_date']"
                    format="D MMM Y"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter({ customLabel: true, name: `Begin date: ${$event}`, value: `${$event}` }, 'begin_date')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >End date</label>
                  <br>
                  <date-picker
                    v-model="filters['end_date']"
                    format="D MMM Y"
                    class="w-100"
                    value-type="format"
                    @change="saveFilter({ customLabel: true, name: `End date: ${$event}`, value: `${$event}` }, 'end_date')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Status of Authorization</label>
                  <v-select
                    v-model="filters.status"
                    label="name"
                    :options="statuses"
                    :get-option-key="option => option.id"
                    @input="saveFilter({ customLabel: true, name: `Status of Authorization: ${$event ? $event.name : ''}`, value: $event }, 'status')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >TSS</label>
                  <select
                    id=""
                    v-model="filters.tss"
                    name=""
                    class="form-select"
                    @input="saveFilter({ customLabel: true, name: 'TSS: ' + ($event.target.value === 'true' ? 'Yes' : ($event.target.value === '' ? 'All' : 'No')), value: $event.target.value }, 'tss')"
                  >
                    <option value="">
                      All
                    </option>
                    <option value="true">
                      Yes
                    </option>
                    <option value="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Insurance</label>
                  <select
                    id=""
                    v-model="filters.travel"
                    name=""
                    class="form-select"
                    @input="saveFilter({ customLabel: true, name: 'Insurance: ' + ($event.target.value === 'true' ? 'Yes' : ($event.target.value === '' ? 'All' : 'No')), value: $event.target.value }, 'travel')"
                  >
                    <option value="">
                      All
                    </option>
                    <option value="true">
                      Yes
                    </option>
                    <option value="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Is virtual?</label>
                  <select
                    id=""
                    v-model="filters.virtual_activity"
                    name=""
                    class="form-select"
                    @input="saveFilter({ customLabel: true, name: 'Is virtual: ' + ($event.target.value === 'true' ? 'Yes' : ($event.target.value === '' ? 'All' : 'No')), value: $event.target.value }, 'virtual_activity')"
                  >
                    <option value="">
                      All
                    </option>
                    <option value="true">
                      Yes
                    </option>
                    <option value="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >ICREA active</label>
                  <select
                    id=""
                    v-model="filters.researcher_active"
                    name=""
                    class="form-select"
                    @input="saveFilter({ customLabel: true, name: 'ICREA active: ' + ($event.target.value === 'true' ? 'Yes' : ($event.target.value === '' ? 'All' : 'No')), value: $event.target.value }, 'researcher_active')"
                  >
                    <option value="">
                      All
                    </option>
                    <option value="true">
                      Yes
                    </option>
                    <option value="false">
                      No
                    </option>
                  </select>
                </div>
              </template>
              <template #info-sheet-item="{item}">
                <template v-if="item.content">
                  <PreviewActivity
                    :item="item"
                  />
                </template>
              </template>
            </CompleteTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import CompleteTable from '../../../partials/components/CompleteTable.vue'
import PreviewActivity from '../components/PreviewActivity.vue'
import 'vue2-datepicker/index.css'
import BriefExplanation from '@/views/back/partials/components/BriefExplanation.vue'

export default {
  components: {
    CompleteTable,
    BDropdown,
    BDropdownItem,
    vSelect,
    DatePicker,
    BriefExplanation,
    PreviewActivity,
  },
  data() {
    return {
      selectedActivity: {},
      sortedField: 'Position',
      defaultFields: [
        {
          name: 'Researcher',
          checked: true,
          order: 1,
        },
        {
          name: 'Type of activity',
          checked: true,
          order: 2,
        },
        {
          name: 'Date',
          checked: true,
          order: 3,
        },
        {
          name: 'Title',
          checked: true,
          order: 4,
        },
        {
          name: 'Event / place',
          checked: true,
          order: 5,
        },
        {
          name: 'Country',
          checked: true,
          order: 6,
        },
        {
          name: 'Virtual',
          checked: true,
          order: 7,
        },
        {
          name: 'Trip dates',
          checked: true,
          order: 8,
        },
        {
          name: 'TSS',
          checked: true,
          order: 9,
        },
        {
          name: 'Insurance',
          checked: true,
          order: 10,
        },
        {
          name: 'Authorization',
          checked: true,
          order: 11,
        },
      ],
      sortMapping: {
        Researcher: 'user.name',
        Title: 'content.title',
        'Event / place': 'event_name',
        'Type of activity': 'content.type.name',
        Country: 'country',
        Date: 'content.date',
        'Trip dates': 'trips_dates',
        TSS: 'tss_table',
        Insurance: 'travel_table',
        Authorization: 'content.status.status_table',
        Virtual: 'content.virtual_activity',
      },
      title: 'Conferences, workshops & invited talks',
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      items: 'activities/items',
      itemsTotal: 'activities/itemsTotal',
      users: 'users/fakeUsers',
      types: 'activityTypes/types',
      statuses: 'status/statuses',
      loggedUser: 'auth/admin',
      filters: 'filters/filters',
      countries: 'citizenships/items',
    }),
  },
  async mounted() {
    this.saveFilter({ customLabel: true, name: `Begin date: 1 Jan ${new Date().getFullYear()}`, value: `1 Jan ${new Date().getFullYear()}` }, 'begin_date')
    if (this.$route.query.user_id) {
      const { data } = await Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/users/show/${this.$route.query.user_id}`)
      const user = data.data
      if (user) {
        this.saveFilter({ customLabel: true, name: `Researcher: ${user.name}`, value: { name: user.name, id: this.$route.query.user_id } }, 'researcher')
      }
    }

    await this.$store.dispatch('modals/fetchUserFields', 'conferences')
    await this.$store.dispatch('activities/setType', 'conferences')
    await this.$store.dispatch('activities/filter', this.$store.getters['filters/filters'])
    await this.$store.dispatch('citizenships/filter', this.$store.getters['filters/filters'])
    await this.$store.dispatch('status/filterStatus', 'Activities')

    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'conferences',
      })
    }
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    saveFilter(value, field) {
      if (!value || (!value.value || (value.value === 'null' || (Array.isArray(value.value) && !value.value.length)))) {
        this.$store.dispatch('filters/deleteFilters', field)
      } else {
        this.$store.dispatch('filters/saveFilters', {
          value,
          field,
        })
      }
    },
    async onSearch(search, store) {
      const s = search
      s.active = true
      if (s.name !== '') {
        await this.$store.dispatch(store, s)
      }
    },
    async showDeleteModal(activity) {
      if (activity.trips.find(trip => trip.tss === true)) {
        Vue.swal('The activity has a trip with TSS aproved', '', 'warning')
        return
      }
      await this.$store.dispatch('modals/saveDeleteData', { name: 'activities/fetch', url: `${Vue.prototype.$groupUrl}/activities/conferences/activity/${activity.id}`, requiredType: 'conferences' })
      this.$store.dispatch('modals/showDeleteModal', true)
    },
    openInfoSheetActivity(field) {
      this.selectedActivity = field
      this.$store.dispatch('modals/toggleInfoItemSheet', true)

      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 200)
    },
  },
}
</script>
